import { Container } from '@/ui-kit';
import styles from './premium-list.module.scss';
import { PremiumItem } from './components/premium-item';
import { Tariff } from '@/types/tariff';
import { useTranslation } from 'react-i18next';
interface Props {
    tariffs?: Tariff[];
    tariffActiveId?: number;
    onChangeTariff: (id: number) => void;
}
export const PremiumList: React.FC<Props> = ({ tariffs, tariffActiveId, onChangeTariff }) => {
    const { t } = useTranslation();

    return (
        <Container className={styles.container}>
            <div className={styles.premiumList}>
                {tariffs?.map((tariff) => (
                    // TODO: transfer isProfit/priceInRub/discount props
                    <PremiumItem
                        onClick={() => onChangeTariff(tariff.id)}
                        key={tariff.id}
                        priceInStars={tariff.amount}
                        date={tariff.title}
                        isActive={tariff.id === tariffActiveId}
                        price={tariff.price}
                        isProfit={tariff.profitable}
                        discount={tariff.discount} />
                ))}
            </div>
            <span className={styles.notice}>
                {t('price_note')}
            </span>
        </Container>
    );
};
